import { Component } from '@angular/core';
import { ApyreAuthService } from '@portal-firebase';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  loading = false;

  constructor(
    private authSvc: ApyreAuthService,
    private router: Router,
    private messageService: MessageService,
  ) {}
  login() {
    if (this.loading) return;
    this.loading = true;

    this.authSvc
      .login()
      .pipe(
        finalize(() => {
          this.loading = false;
        }),
      )
      .subscribe({
        next: (isLoggedIn) => {
          if (isLoggedIn) {
            this.router.navigate(['/app']);
          }
        },
        error: (e) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Login Failed',
            life: 5000,
            detail: 'Please login with a valid Apyre® email account.',
          });
        },
      });
  }
}
